/**
 * useCategories — Fetches and caches goal category definitions from the database.
 */
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "./useAuth";
import { logger } from "@/utils/logger";

export interface Category {
  id: string;
  name: string;
  created_at: string;
}

export const useCategories = () => {
  const { user } = useAuth();
  
  return useQuery({
    queryKey: ["categories"],
    queryFn: async () => {
      logger.debug("Fetching categories...");
      const { data, error } = await supabase
        .from('categories')
        .select('*')
        .order('name');

      if (error) {
        logger.error("Error fetching categories:", error);
        throw error;
      }

      logger.debug("Categories fetched:", data?.length);
      return (data || []) as Category[];
    },
    // Don't run the query if user is not authenticated
    enabled: !!user,
    staleTime: 5 * 60 * 1000, // 5 minutes
    retry: 3,
    retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
  });
};
